import { useEffect, useState } from 'react'

/** Текущее время (мс), обновляется каждые `intervalMs`. Для таймеров «до фандинга»
 *  и «обновлено N назад». Один интервал на компонент — лёгкий. */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs)
    return () => clearInterval(id)
  }, [intervalMs])
  return now
}
